module.exports = {
  appName: "立讯技术零件处生产运营系统",
  message: {
    title: "系统提示",
    error_factory_code_not_input: "请输入工厂编码",
    error_employee_code_not_input: "请输入员工编码",
    error_custom_code_not_input: "请输入客户编码",
    error_verify_code_not_input: "请填写验证码",
    error_login_password_not_input: "请输入登录密码",
    error_device_code_not_input: "请输入设备编码",
    error_info: "错误信息",
    error_ajax: "数据请求出错，请刷新后重试！",
    error_not_login: "请登陆后重试!",
    error_permission_validate: "你没有权限执行当前操作!",
    error_can_empty: "当前项不能为空！",
    error_opera_retry: "操作失败，请重试!",
    timeout: "连接超时，请重试!",
    error_sysdate_can_not_execute_current_opera: "系统数据，不能执行该操作!",
    error_can_not_delete_because_used: "当前数据被使用中,不能删除!",
    error_code_same_pleas_change: "编码重复，请确认!",
    has_children_can_not_delete: "存在子项，不能删除!",
    please_input_required_items: "请输入必填项!",
    please_select_row_to_opera: "请选择要操作的数据",
    please_check_row_to_opera: "请勾选要操作的数据",
    can_not_delete_system_data: "系统数据，不能删除",
    error_404: "您访问的页面不存在",
    error_403: "您没有权限访问当前页面",
    error_go_back: "返回上一页",
    error_go_login: "返回登录",
    Employee_Code_does_not_exist: "员工编码【%1】不存在",
    Device_code_does_not_exist: "设备编码【%1】不存在",
    Craft_code_does_not_exist: "工序编码【%1】不存在",
    please_select_part_to_opera: "请选择要操作的零件",
    please_select_process_to_opera: "请选择要操作的工艺",
    old_password_error: "原始密码错误",
    confirm_delete_data: "确认要删除选中数据吗？",
    error_param_validate: "参数校验失败，请确认是否非法访问!"
  },
  login: {
    login: "登录",
    remember: "记住密码",
    verify_code: "验证码"
  },
  nav: {
    produce_order: "工单管理",
    process_manage: "CAPP管理",
    progress_query: "零件进度查询",
    quality_manage: "质量管理",
    quality_determine: "品质异常反馈",
    quality_penalty: "质量处罚",
    quality_recall: "质量召回",
    system_setting: "系统设定",
    modify_password: "修改密码",
    personal_center: "个人中心",
    exit_system: "退出登录",
    plan: "计划管理",
    forms: "车间无纸化管理",
    report:"生产执行管理",
    basic_data: {
      title: "基础资料",
      factory_setting: "厂区设定",
      department_manage: "部门管理",
      role_manage: "角色管理",
      employee_manage: "员工管理",
      device_manage: "设备管理",
      operation_manage: "工序管理",
      production_line_manage: "产线管理",
      cost_type_manage: "费用类型",
      shelf_manage: "货架管理",
      work_group_manage: "作业组管理",
      software_download: "软件下载",
      report_quality_department: "质量部报表"
    },

    classify_setting: {
      title: "分类设定",
      product_type: "产品类型",
      order_type: "订单类型",
      part_classify: "零件分类",
      error_classify: "错误分类",
      project_classify: "项目分类"
    },
    job_deployment: "作业部署",
    standard_process_library: "CAPP管理系统",
    custom_column: "自定义列",
    log_manage: "日志管理",
    approval_process: "审批流程",
    class_table_setting: "班表设定",
    holiday_setting: "假日设定",
    offline_file_setting: "车间无纸化管理系统",
    standard_procedure_setting: "指导书设定",
    project_master_plan: "主计划",
    project_master_plan_template_setting: "主计划模板设定",
    customer_form: "自定义表单"
  },
  common: {
    opera: "操作",
    open: "打开",
    upload: "上传",
    file: "文件",
    setting: "设定",
    factoryCode: "工厂编码",
    employeeCode: "员工编码",
    LoginPassword: "登录密码",
    add_user: "添加人",
    add_time: "添加时间",
    update_user: "更新人",
    update_time: "更新时间",
    add: "添加",
    save: "保存",
    saveAndAdd: "保存并继续添加",
    reset: "重新填写",
    cancel: "取消",
    delete: "删除",
    edit: "编辑",
    query: "查询",
    print: "打印",
    print_count: "打印次数",
    img_is_not_upload: "图片未上传",
    confirm: "确认",
    filter: "筛选",
    please_input_filter_content: "请输入筛选内容",
    default_value_setting: "默认值设定",
    name: "名称",
    remark: "备注",
    display: "显示",
    hide: "隐藏",
    move: "移动",
    copy: "复制",
    see: "查看",
    split: "分割",
    recovery_split: "恢复分割",
    more: "更多",
    approved: "已审批",
    approval_status: "审批状态",
    approval_sponsor: "审批发起人",
    approver: "审批人",
    approval_approval: "审批通过",
    approval_return: "审批退回",
    ongoing: "进行中",
    opera_type: "操作类型",
    code: "编码",
    capacity: "产能",
    select_department: "选择部门",
    select_resources: "选择资源",
    craft: "工序",
    production_line: "产线编码",
    status: "状态",
    today: "今天",
    import_start_row: "起始行",
    select_craft: "选择工序",
    amount: "金额",
    paste: "粘贴",
    close_copy_model: "退出复制模式",
    reset_cache: "重置浏览器缓存"
  },
  password: {
    original_password: "原始密码",
    new_password: "新密码",
    confirm_password: "确认密码",
    error_please_input_original_password: "请输入原始密码",
    error_please_input_new_password: "请输入新密码",
    error_please_input_confirm_password: "请输入确认密码",
    error_please_input_password_not_same: "两次输入的密码不一致",
    default_password_tip: "员工默认密码:123456",
    reset_password: "重置密码",
    password_is_reset: "密码重置成功，新的密码为: 123456"
  },
  status: {
    scrap: "报废",
    normal: "正常",
    repair: "维修"
  },
  basic_data: {
    nav_width: "190px",
    role_manage: {
      role_name: "角色名称",
      used_count: "使用次数",
      role_type: "角色类型",
      role_permissions: "角色权限",
      system_role: "系统角色",
      custom_role: "自定义角色"
    },
    department_manage: {
      Superior_department: "上级部门",
      Department_code: "部门编码",
      Department_name: "部门名称",
      work_condition: "工作状态",
      work_status_on: "启用",
      work_status_off: "停用",
      add_sub_department: "添加子部门",
      add_brother_department: "添加同级部门"
    },

    employee_manage: {
      status_on_the_job: "在职",
      status_vacation: "休假",
      status_quit: "离职",
      employee_code: "员工编码",
      employee_name: "员工名称",
      employee_role: "员工角色",
      subordinate_department: "所属部门",
      department_establishment_number: "部门编制号",
      working_condition: "工作状态",
      normal_production_capacity: "正常产能",
      budgetary_capacity: "预算产能",
      id_number: "身份证号",
      departmental_role: "部门角色",
      department_staff: "部门员工",
      department_head: "部门主管",
      phone_number: "电话号码",
      email: "邮箱",
      user_code_same: "员工编码重复!"
    },
    device_manage: {
      working_condition: "工作状态",
      device_code: "设备编码",
      device_name: "设备名称",
      equipment_brand: "料管内径",
      producing_area: "设备型号",
      Normal_capacity: "正常产能",
      Maximum_capacity: "最大产能",
      Budget_capacity: "预算产能",
      nc_sys_version: "数控系统版本号",
      status_img_off: "离线图片",
      status_img_free: "空闲图片",
      status_img_on: "运行图片",
      status_img_error: "报警图片",
      error_please_input_device_code: "请输入资产编号",
      error_please_input_device_name: "请输入资产名称",
      click_to_upload: "点击上传",
      click_to_upload_or_edit: "点击查看/修改",
      text_img_management: "图片管理",
      img_view: "图片查看",
      target_utilization: "目标稼动率"
    },
    cost_type_manage: {
      cost_type: "费用类型",
      cost_type_code: "费用类型编码",
      cost_type_name: "费用类型名称",
      parent_cost_type_code: "父费用类型编码",
      parent_cost_type_name: "父费用类型名称",
      edit_parent_cost_type: "编辑父费用类型",
      edit_sub_cost_type: "编辑子费用类型"
    },
    operation_manage: {
      manual_operation: "手动工序",
      automatic_process: "自动工序",
      subsidiary_process: "附属工序",
      outside_the_plan: "计划外工序",
      procurement_process: "采购工序",
      outside_process: "外协工序",
      internal_process: "内制工序",
      project_process: "项目工序",
      parent_process_coding: "父工序编码",
      process_coding: "工序编码",
      process_name: "工序名称",
      process_attributes: "工序属性",
      process_type: "工序类型",
      conversion_process: "转换工序",
      clamping_procedure: "钳制工序",
      report_way: "报工方式",
      scheduling_attributes: "排程属性",
      cost_type: "费用类型",
      default_preparation_time: "准备工时",
      default_device_hours: "设备工时",
      default_manpower_hours: "人力工时",
      according_to_production_parameters: "按生产参数",
      ordinary: "普通",
      according_to_materiel_out_of_stock_code: "按物料出库条码",
      allowable_excess_capacity: "允许超产能",
      prohibition_excess_capacity: "禁止超产能",
      default_part_size: "默认零件大小",
      large_part_size: "大型零件",
      medium_part_size: "中型零件",
      small_part_size: "小型零件",
      default_transfer_time: "转移时间",
      default_preset_days: "预置天数",
      general_parts: "一般零件",
      core_parts: "核心零件",
      material_retrieval_code: "物料出库条码",
      bar_code_content: "条码内容",
      attribute_type: "属性类型",
      attribute_detail: "属性明细",
      craft_process_parameters: "工序加工参数",
      craft_public_type: "工序公共属性",
      attribute_detail_single_tips:
        "属性明细只能添加一条记录,若修改请先删除记录",
      is_leapfrog: "是否允许跳步",
      wage_calc_type: "工资计算方式",
      plan_reason_of_uncompleted: "计划未完成类型",
      plan_reason_of_uncompleted_remark: "计划未完成说明",
      plan_remedial_measures: "计划补救措施",
      plan_remedial_measures_remark: "补救措施说明",
      customer_related_craft: "客户关联工序",
      customer_process_code: "客户工序编码",
      customer_process_name: "客户工序名称"
    },
    production_line_manage: {
      production_line_code: "产线编码",
      production_line_name: "产线名称"
    },
    shelf_manage: {
      shelf_code: "货架编码",
      shelf_name: "货架名称",
      shelf_remark: "货架备注"
    },
    custom_manage: {
      title: "客户管理",
      custom_code: "客户编码",
      custom_name: "客户简称",
      custom_full_name: "客户全称",
      custom_address: "地址",
      custom_area: "区域",
      custom_tel: "电话",
      custom_fax: "传真",
      custom_mail: "邮箱"
    },
    base_materiel: {
      mat_code: "物料编码",
      mat_name: "物料名称",
      def_spec: "默认规格",
      def_calc_num: "默认单量",
      def_price: "标准单价"
    },
    calculation_formula: {
      title: "计算公式",
      formula_mrp: "MR",
      formula_title: "公式名称",
      formula_content: "公式内容",
      formula_value_type: "取值方式",
      formula_value_normal: "默认",
      formula_value_ceil: "向上取整",
      formula_value_floor: "向下取整",
      order_columns: "订单列",
      part_columns: "零件列",
      process_columns: "工艺列",
      mrp_columns: "MR列",
      formula_error_tips: "计算公式有误，请重新选择公式或修改后重试！",
      shape: "形状",
      length: "长",
      width: "宽",
      high: "高"
    }
  },
  job_deployment: {
    operation_group: "作业组",
    administrative_department: "管理部门",
    operation_group_coding: "作业组编码",
    name_of_operation_group: "作业组名称",
    normal_production_capacity: "正常产能",
    maximum_capacity: "最大产能",
    association_process: "关联工序",
    associated_production_line: "关联产线",
    associated_resources: "资源",
    resource_type: "资源类型",
    resource_coding: "资源编码",
    resource_name: "资源名称",
    staff: "员工",
    equipment: "设备",
    shelves: "货架",
    work_attributes: "工作属性",
    job_level: "作业等级",
    partTime_productivity: "兼职产能",
    fullTime: "全职",
    partTime_job: "兼职",
    downtime: "停机",
    apprentice: "学徒",
    primary: "初级",
    intermediate: "中级",
    senior: "高级",
    expert: "专家",
    group_resources_delete_intercept:
      "选中资源中，部分资源已经分配给工序，不能删除！",
    craft_resources: "工序资源"
  },
  custom_column: {
    integer: "整数",
    decimal: "小数",
    text: "文本(500字以内)",
    date: "日期",
    column_type: "列类型",
    system_definition_column: "系统定义列",
    upper_shift: "上移列",
    down_shift: "下移列",
    employee_selection: "员工选择",
    device_selection: "设备选择",
    show_in_table: "表格中可见",
    hide_in_table: "表格中隐藏",
    img: "图片",
    column_width: "列宽/ps",
    column_attribute: "列属性"
  },
  produce_order: {
    diagram: "简图",
    order_area: "工单区域",
    processing_order: "在制工单",
    completion_order: "完工工单",
    area_name: "区域名称",
    can_report: "参与报工",
    can_schedule: "参与排产",
    add_sub_area: "添加子区域",
    add_brother_area: "添加同级区域",
    internal_part_only: "仅内制零件",
    internal_and_external_part: "内制和外发零件",
    lock_plan: "锁定计划",
    not_locked: "不锁定",
    production_work_order: "生产工单",
    rate_of_progress: "进度",
    delay_days: "延误",
    copy_order_plan: "复制生产工单主计划",
    copy_part_and_process: "复制零件及工艺",
    copy_try_count: "复制调试次数",
    target_try_count: "目标调试次数",
    order_attribute: "工单属性",
    plan_attribute: "计划属性",
    product_attribute: "产品属性",
    customer_attribute: "客户属性",
    calling_bom: "调用工艺",
    can_automatic: "自动移动完工"
  },
  produce_part: {
    part_list_title: "零件列表",
    part_select_all: "全选",
    part_un_select: "反选",
    part_attribute_default: "全部",
    part_attribute_part: "零件",
    part_attribute_sub: "附属零件",
    part_attribute_design: "设计",
    part_attribute_assemble: "装配",
    part_attribute_debug: "调试",
    part_attribute_project: "项目",
    produce_part_split: "零件分割",
    part_split_error_message: "手动输入的数量超过了总数量,请重新输入!",
    part_code_exist: "【%1】已存在",
    part_delete_tips: "此操作将删除选中的【%1】个数据, 是否继续?",
    part_copy_tips: "此操作将复制选中的【%1】个数据, 是否继续?",
    emergency_order: "紧急插单",
    emergency_order_cancel: "取消插单",
    emergency_order_confirm: "确定要执行紧急插单吗？",
    emergency_order_icon: "插单",
    part_copy_of_order: "复制订单零件",
    change_try_count: "调试次数",
    part_history: "零件履历",
    convenient_parts_stickers: "便利零件贴",
    convenient_parts_stickers_pdf: "便利零件贴PDF",
    part_attribute: "零件属性",
    part_project_attribute: "工程属性",
    part_master_plan_setting: "零件里程碑设定",
    part_barcode_of_subcontract: "零件分包条码"
  },
  product_bom: {
    product_bom_title: "产品Bom",
    internal: "內制",
    purchase: "采购"
  },
  produce_part_sub_list: {
    part_sub_list_title: "附属零件列表",
    part_sub_list_column_orderIndex: "序号",
    part_sub_list_column_file: "AP工艺技术文件",
    part_sub_list_choose_title: "选择附属零件列表",
    part_sub_list_selected: "选中列表"
  },
  produce_bom: {
    produce_bom_check_parent_tip: "请选择父级bom!"
  },
  produce_process: {
    process: "工艺",
    process_list: "工艺列表",
    produce_process_split: "工艺分割",
    please_input_required_split_num: "请输入分割数量",
    process_split_num: "分割数量",
    process_split_st: "分割工时",
    part_card: "零件工序卡",
    part_card_for_bao_shun: "零件工序卡(宝顺)",
    process_card: "工艺工序卡",
    same_crafts_card: "相同工序卡",
    process_achievement: "实绩明细",
    process_state_un_start: "未开始",
    process_state_processing: "加工中",
    process_state_completed: "已完工",
    process_state_suspended: "暂停加工",
    process_state_scrapped: "报废",
    process_state_purchase: "特采",
    process_state_received: "接收",
    process_state_part_received: "部分接收",
    process_state_un_completed: "未完工",
    appoint_time_tips: "开始时间不能大于结束时间!",
    sample_batch: "抽检批量",
    check_num: "抽检数量",
    check_cycle: "抽检周期",
    sample_batch_tips: "抽检批量不能大于工艺数量！",
    check_num_tips: "抽检数量不能大于抽检批量和工艺数量",
    cancel_pause: "取消暂停",
    process_offline: "强制下机",
    cancel_process_offline: "取消下机",
    auto_compute_st: "自动计算"
  },
  process_library: {
    standard_order: "标准BOM",
    customer_standard_order: "客户BOM",
    template_no: "产品编码",
    template_name: "产品名称",
    template_attribute: "产品属性",
    template_type: "产品分类",
    template_attribute_craft: "工序",
    template_attribute_project: "项目模板",
    import_part_process: "导入零件和工艺",
    import_part: "导入零件",
    import_process: "导入工艺",
    template_not_empty: "模板编码或模板名称不能为空!",
    add_child_part: "子级零件",
    import_process_library: "导入CAPP管理系统",
    internal_process: "内部工序",
    external_process: "外部工序",
    lib_cover_bom: "覆盖",
    lib_cover_bom_tooltip: "覆盖，会清除原有的，以当前导入为准！"
  },
  process_mrp: {
    consumable_name: "耗品名称",
    bill_of_materials: "物料单重",
    surplus_material_weight: "用量",
    part_few: "一出几",
    bad_rate: "组件报废",
    calculate_unit: "计量单位",
    demand_unit: "需求单位",
    demand_unit_conversion: "需求单位换算",
    required_quantity: "需求数量",
    arrival_quantity: "到货数量",
    latest_arrival_time: "最晚到货时间"
  },
  approval_process: {
    Approval_type: "审批类型",
    Associated_data: "关联数据",
    Approval_add: "审批添加",
    Approval_modification: "审批修改",
    Approval_deletion: "审批删除",
    Process_name: "流程名称",
    Process_notes: "流程备注",
    Approval_process: "审批流程",
    Reporting_time: "上报时间/H",
    Approval_intercept: "审批拦截",
    Departmental_approval: "部门审批",
    superior_departments_approval: "上级部门审批",
    custom_approval: "自定义流程",
    All_approval: "审批全部",
    All_data_will_be_approved: "全部数据按该流程审批",
    Approval_by_order_type: "按工单类型审批",
    Data_specifying_only_the_type_of_work_order:
      "批指定工单类型的数据按该流程审批",
    Approval_by_product_type: "按产品类型审批",
    Data_that_specifies_only_product_types: "指定产品类型的数据按该流程审批",
    please_select_approval_process: "请选择审批流程"
  },
  approval_process_setting: {
    add_root_node: "添加审批节点",
    auditor: "审核人"
  },
  report: {
    report_type: "报工类型",
    report_receive: "接收",
    report_start: "开始",
    report_unfinished: "未完工",
    report_finished: "完工",
    report_outside: "计划外",
    report_outside_report: "计划外报工",
    report_bar_code: "报工条码",
    report_single_person: "单人报工",
    report_many_people: "多人报工",
    report_feedback: "异常反馈",
    report_part_schedule: "零件进度",
    report_record: "报工记录",
    report_source: "报工来源",
    view_work_reporting_barcode: "查看报工条码",
    appoint_resource_code: "指定资源编码",
    appoint_resource_name: "指定资源名称",
    previous_process: "上道工艺",
    next_process: "下道工艺",
    operation_user: "实际操作人",
    scan_barcode: "是否扫描条码",
    code_type: "条码类型",
    qr_code: "条码",
    packet_number: "包数",
    finished_quantity_cannot_be_less_than: "完工数量不能小于0.01",
    the_start_quantity_cannot_be_greater_than_the_machinable_quantity:
      "开始数量不能大于可加工数",
    batch_requisition_can_only_be_executed_under_the_same_processing_condition:
      "相同加工状态才可以执行批量报工",
    same_process_can_be_applied_for_batch_work: "相同工序才可以执行批量报工",
    barcode_already_exists: "条码已经存在",
    barcode_format_is_wrong: "条码格式不对",
    are_you_sure_you_want_to_perform_operations_on_processes:
      "要对[$1]道工艺进行[$2]操作，确定要执行吗?",
    selected_process_exists_already_started_process: "选中工艺存在已开始工艺!",
    tips_for_multiple_workers:
      "当前任务由多人完成，您需报【未完工】，并输入个人实际完成数量或完成比率】",
    There_is_an_unacceptable_process_in_the_selected_process:
      "选中工艺中存在不能接收的工艺!",
    No_finished_quantity_in_the_previous_process:
      "选中工艺中存在上道工艺没有完工数量，不能接收！",
    There_is_no_starting_process_in_the_selected_process:
      "选中工艺中存在未开始工艺！",
    batch_operation_not_supported_finish:
      "当前报工不支持批量操作，请单独选择报工，如为批量开始的工艺，则自动批量执行!",
    confirm_batch_report_finish:
      "当前工艺为批量开始，是否同时批量操作的其他工艺？",
    Batch_reporting: "批量报工",
    Unpacking: "拆包报工",
    Batch_start: "批量开始",
    Batch_completion: "批量完工",
    Unfinished_batch: "批量未完工",
    Batch_reception: "批量接收",
    report_info_setting: "报工信息设置",
    send_remark: "交接说明",
    receive_num: "接收数量",
    send_user: "发送人",
    message_please_select_resources_for_insert: "请选择$1",
    mach_num: "加工数量",
    finish_num: "完成数量",
    un_finish_num: "未完成数量",
    mach_user: "加工人",
    mach_device: "加工设备",
    completion_rate: "工时完成率",
    confirm_batch_finish:
      "将要对选中的工艺,及其批量开始的工艺进行完工操作,确定执行吗？",
    confirm_batch_un_finish:
      "将要对选中的工艺,及其批量开始的工艺进行未完工操作,批量未完工完成数量及完成率皆为0,确定执行吗?",
    process_is_not_existence: "工艺不存在!",
    process_can_not_report: "该工艺不能报工!",
    process_is_existence_to_select: "工艺存在!",
    process_can_mach_num_is_zero: "选中工艺可加工数量为0!",
    previous_process_is_not_finish: "上道工艺未完工，当前工艺不能开始!",
    has_previous_process_not_finish_process:
      "选中工艺中，存在上道工艺未完工的工艺，不能开始!",
    total_st: "总工时",
    finish_st: "完成工时",
    process_can_not_add_report_detail: "当前工艺没有可报工数量，不能添加!",
    report_by_param_can_not_batch_report: "按生产参数报工的工艺，不能批量报工!",
    report_by_material_out_barcode_can_not_batch_report:
      "按物料出库条码报工的工艺，不能执行批量报工！",
    please_input_material_out_barcode: "请输入物料出库条码!",
    finish_ratio: "完成率",
    current_finish_ratio: "本次完成率",
    can_not_report_un_finish_return_to_finish: "全部加工完成，请报完工！",
    has_package_process_single_report: "存在打包的工艺，是否拆包报工？",
    pack_process_list: "打包工艺列表",
    pack_single_report: "拆包报工",
    part_technical_file: "零件技术文件",
    process_technical_file: "工艺技术文件",
    max_hour: "最小不能小于1分钟，最大不能超过24小时",
    report_deplane: "下机",
    report_operate_a_computer: "上机",
    start_num: "开始数量",
    error_num: "不良数量",
    problem_classification: "不良类型",
    problem_description: "问题说明",
    please_input_start_num: "请输入开始数量",
    report_material_code: "物料条码",
    mat_code_can_not_repeat: "条码不能重复",
    mat_code_not_null: "条码不能为空",
    process_finish: "工艺当前报工记录已经加工完成，请执行完工操作",
    batch_number: "报工批次号",
    file_size_error: "文件大小不能超过5M",
    finish_num_max_error: "最大完工数量不能大于报工数量",
    error_not_set_mrp: "请先设置工艺的MR",
    time_interval: "时间区间",
    anomaly_classification: "异常分类",
    abnormal_quality: "质量异常",
    abnormal_production_line: "产线异常",
    abnormal_plan: "计划异常",
    mould_status: "模具状态",
    finish_tips: "提示：如任务未完工，请输入已完成数量，否则默认为完工",
    laden_manage: "拉灯管理"
  },
  class_table_setting: {
    Employee_class_table: "员工班表",
    Equipment_class_table: "设备班表",
    Holiday_setting: "假日设定",
    Factory_holiday: "工厂假日",
    Employee_holiday: "员工假日",
    set_month: "设定月份",
    class_table: "班表",
    detail: "明细",
    start_time: "开始时间",
    end_time: "结束时间",
    to_be_on_duty: "值日",
    rest: "休息",
    interrupt: "中断"
  },
  progress: {
    show_finished_parts: "完工零件",
    show_plan_time: "计划时间",
    show_actual_time: "实际时间",
    show_standard_st: "标准工时",
    show_actual_st: "实绩工时",
    show_craft_name: "工序名称",
    show_finish_day: "延误天数",
    out_of_parts: "零件外发",
    combined_processing: "组合加工",
    process_synchronization: "工艺同步",
    composite_relations_View: "组合关系",
    parts_filter: "零件筛选",
    add_sync: "添加同步",
    sync_record: "同步记录",
    start_date: "起始日期",
    end_date: "结束日期",
    outgoing_process: "外发工艺",
    outgoing_num: "外协数量",
    outgoing_date: "外发日期",
    pre_parts: "前置零件",
    pre_process: "前置工艺",
    rear_parts: "后置零件",
    postprocess: "后置工艺",
    combination_type: "组合类型",
    process_combination: "工艺组合",
    part_assembly: "零件组合",
    message_The_current_process_exists_please_do_not_add_it_again:
      "当前工艺以存在，请不要重复添加！",
    message_Can_not_assemble_the_same_parts: "不能组合相同的零件！",
    message_The_number_of_adding_processes_on_this_side_has_reached_the_maximum:
      "本侧添加工艺数量已达到最大值！",
    message_The_current_process_has_been_the_process_of_external_collaboration:
      "当前工艺已经是外协工序！",
    message_The_current_process_processing_status_does_not_allow_outsourcing:
      "当前工艺加工状态不允许外发！",
    message_The_process_code_of_synchronous_process_must_be_the_same:
      "同步工艺的工序编码必须相同！",
    pack_type: "打包类型",
    pack_type_same_order: "同工单打包",
    pack_type_more_order: "跨工单打包"
  },
  holiday_setting: {
    factory_holiday_setting: "厂区假日设定",
    monday: "一",
    tuesday: "二",
    wednesday: "三",
    thursday: "四",
    friday: "五",
    saturday: "六",
    sunday: "日",
    factory_holiday: "工厂假日",
    user_overtime: "员工加班",
    user_holiday: "员工假日",
    user_holiday_tip: "如果设定日期为工厂假日，则状态为员工加班."
  },
  offline_file_setting: {
    file_describe: "文件描述",
    storage_type: "存储类型",
    file_format: "文件格式",
    classify_name: "分类名称",
    respective_region: "所属区域",
    storage_type_local: "本地文件",
    storage_type_ftp: "ftp文件",
    storage_type_sftp: "sftp文件",
    respective_region_project: "项目文件",
    respective_region_order: "工单文件",
    respective_region_part: "零件文件",
    respective_region_process: "工艺文件",
    start_path: "起始路径",
    server_host: "服务器IP",
    server_port: "服务器端口",
    server_user_name: "登录账户",
    server_user_password: "登陆密码",
    label_width: "100px",
    file_path: "文件路径",
    add_fuzzy_path: "添加模糊路径",
    add_fuzzy_path_confirm:
      "添加模糊路径后，不支持文件上传，需要手动操作，确定继续吗？",
    error_add_path: "请设置路径",
    file_classify: "文件分类",
    classify_setting: "文件分类设定"
  },
  standard_procedure_setting: {
    title: "标题",
    width: "宽度",
    table: "表格",
    table_setting: "表格设定",
    production_params: "生产参数",
    add_plan_row: "添加计划参数",
    add_real_row: "添加实际参数",
    device_operating_params: "设备运行参数",
    show_line_number: "显示行号",
    show_row_number: "显示行数",
    comparison_table: "比对表格",
    comparison_table_setting: "比对表格设定",
    comparison_mode: "比对方式",
    comparison_mode_1: "横向比对",
    comparison_mode_2: "纵向比对",
    reference_column: "参照列名称",
    each_generation_reference_column: "每次比对生成参照列",
    comparison_column_number: "比对列数量",
    comparison_column: "比对列名称",
    form: "表单",
    form_setting: "表单设定",
    add_row: "添加行",
    delete_row: "删除行",
    add_column: "添加列",
    column_type: "列类型",
    column_number: "列数",
    column_format: "列格式",
    column_name: "列名称",
    row_span: "跨越行数",
    column_span: "跨越列数",
    show_text: "显示文本",
    input_box: "输入框",
    data_type: "数据类型",
    double_reserved_points_prepend: "保留",
    double_reserved_points_append: "位小数点",
    year: "年",
    month: "月",
    day: "日",
    hour: "时",
    minute: "分",
    second: "秒",
    show_code: "显示编码",
    show_name: "显示名称",
    show_code_and_name: "显示编码和名称",
    current_row_can_not_add_column: "当前行不能添加列!",
    filed_column: "列字段"
  },
  produce_plan: {
    plan_versions: "计划版本",
    import_title: "导入",
    download_title: "导出",
    upload_title: "导入计划",
    chooseFile: "选择文件",
    uploadTip: "只能上传xlsx/xls文件，且不超过50M!",
    plan_of_day_title: "班组日计划",
    appoint_day_plan: "设定日计划",
    cancel_day_plan: "取消日计划",
    produce_day_plan: "日计划",
    non_existent: "不存在！",
    load_st: "负荷工时",
    modal_cloud_setting: "模云设定",
    middle_schedule: "中日程",
    part_middle_schedule: "零件中日程",
    small_schedule: "小日程",
    waiting_area: "待接收区",
    processing_area: "待加工区",
    completion_area: "完工区",
    employee_performance: "员工绩效",
    produce_plan_load: "生产负荷",
    stagnation_time: "呆滞时间",
    receive_time: "接收时间",
    start_time: "开始时间",
    end_time: "结束时间",
    is_cover: "是否覆盖计划",
    change_priority: "调整优先度",
    unscheduled_plan: "未排计划工艺",
    day_plan_record: "日计划日志",
    setting_record: "设定日志",
    cancel_record: "取消日志",
    cancel_reason: "取消原因",
    designated_resource: "指定资源",
    set_reason_of_uncompleted: "设定未完成原因",
    set_remedial_measures: "补救措施",
    date_not_min_than_last_end: "开始日期不能晚于上道工艺的开始日期",
    startDate_not_greater_than_endDate: "开始日期不能大于结束日期",
    endDate_not_min_than_startDate: "结束日期不能小于开始日期",
    batch_confirm_plan: "批量确认计划",
    cycle_schedule: "周期排程",
    cycle_schedule_setting: "周期排程设定"
  },
  cycle_schedule: {
    cycle_title: "周期名称"
  },
  produce_plan_load: {
    produce_plan_load_st: "负荷工时:",
    capacity_tip: "标准产能",
    max_capacity_tip: "最大产能"
  },
  quality_manage: {
    execute_state: "处理状态",
    operation: "操作",
    po_num: "PO号",
    delivery_note_num: "送货单号",
    remedy_user: "判定人",
    duty_process: "责任工艺",
    find_process: "发现工序",
    remedy_time: "判定日期",
    wait_for_initiation: "等待发起",
    remedies_will_signed: "补救措施会签中",
    remedial_measures_were_not_signed: "补救措施会签未通过",
    quality_tracing: "质量追溯",
    quality_analysis: "质量分析",
    quality_traceability_signature_ing: "质量追溯会签中",
    finished_process: "处理完毕",
    cancelled: "已取消",
    jointly_sign: "会签",
    remedial_measures: "补救措施",
    person_liable: "责任人",
    find_people: "发现人",
    quantity_of_rework: "返工数量",
    error_classification: "错误分类",
    error_reason: "错误原因",
    specific_quantity: "特采数量",
    scrap_quantity: "报废数量",
    common_signer_settings: "常用会签人设定",
    initiating_countersign: "发起会签",
    unsigned_execution: "无会签执行",
    counter_signer: "会签人",
    countersignature_status: "会签状态",
    countersigned_endorsement: "会签批注",
    countersignature_time: "会签时间",
    abandonment: "报废下发",
    staff_coding: "员工编码",
    employee_name: "员工名称",
    remedies_will_be_signed: "补救措施会签",
    quality_traceability_signature: "质量追溯会签",
    selection_of_signers: "选择会签人",
    to: "于",
    cancel_countersign: "取消会签",
    adopt: "通过",
    not_pass: "未通过",
    no_countersigned: "未会签",
    label_width: "70px",
    loss_label_width: "80px",
    label_value_margin: "0px",
    please_select_responsible_process: "请选择责任工艺",
    please_select_the_person_responsible: "请选择责任人",
    please_select_the_discovery_process: "请选择发现工艺",
    please_select_the_discoverer: "请选择发现人",
    please_enter_the_quantity_of_rework: "请输入返工数量",
    please_select_the_error_classification: "请选择错误分类",
    please_enter_the_special_quantity: "请输入特采数量",
    please_enter_the_amount_of_scrapped: "请输入报废数量",
    please_choose_the_way_to_deal_with_it: "请选择处理方式",
    please_select_the_data_that_needs_to_be_signed: "请选中需要执行会签的数据",
    successful_operation: "操作成功",
    penalty_charge: "处罚收费",
    amount_of_penalty: "处罚金额",
    loss_of_working_hours: "损失工时(H)",
    loss_due_date: "损失交期",
    loss_of_material_cost: "损失材料成本",
    loss_of_manufacturing_costs: "损失制造成本",
    penalty_notes: "处罚说明",
    will_sign_back_history: "会签退回历史",
    responsibility_judgement: "责任判定",
    punished_person: "被处罚人",
    please_choose_the_person_to_be_punished: "请选择被处罚人",
    quality_traceability_will_sign_back_records: "质量追溯会签退回记录",
    will_sign_the_withdrawal_record: "会签撤回记录",
    operator_coding: "操作人员编码",
    operator_name: "操作人员名称",
    operation_time: "操作时间",
    details_of_withdrawal_records: "会签撤回记录明细",
    coding_of_responsible_person: "责任人编码",
    name_of_responsible_person: "责任人名称",
    responsible_human_type: "责任人类型",
    responsibility_ratio: "责任占比",
    supplier: "供应商",
    factory_staff: "本厂员工",
    supplier_staff: "供应商员工",
    general_factory_staff: "总厂员工",
    adding_responsible_persons: "添加责任人",
    yes: "是",
    no: "否",
    the_selected_signer_is_not_identical_with_the_actual_signer:
      "选中的会签人与实际会签人不一致，无法进行会签",
    display_completed_items: "显示已完成项",
    delete_successfully: "删除成功！",
    canceled_deletion: "已取消删除",
    this_action_will_delete_the_selected: "此操作将删除选中的",
    an_exception_list_do_you_want_to_continue: "个异常单, 是否继续?",
    only_canceled_data_can_be_deleted_the_current_selected_item_contains_other_states:
      "只能删除已取消状态的数据，当前选中项中含有其他状态！",
    rework: "返工",
    degrade: "特采",
    scrap: "报废",
    you_signed_up_and_can_participate_again: "你已会签完毕，不能再次参与",
    personnel: "人员",
    number: "数量",
    actual_technology_parameter: "工序参数",
    indirect_material_cost: "间接材料成本",
    problem_classification: "异常类型",
    problem_description: "问题描述",
    quality_abnormality: "质量异常",
    save_and_continue_add_exceptions: "保存并继续添加异常",
    quality_feedback: "质量反馈",
    bad_num: "不良数量",
    view_files: "查看文件"
  },
  project_master_plan: {
    node_setting: "计划节点设定",
    node_code: "节点编码",
    node_name: "节点名称",
    node_type: "节点类型",
    production_node: "生产节点",
    purchase_node: "采购节点",
    project_node: "项目节点",
    ability: "能力 H/D",
    max_ability: "最大能力 H/D",
    node_cost_type: "计划节点 - 费用类型",
    cost_type_part_classify: "费用类型 - 零件分类",
    by_month: "按月",
    by_week: "按周",
    by_day: "按日",
    by_hours: "按小时",
    plan: "计划",
    estimated_st: "预估工时",
    related_node: "关联节点",
    relation_type: "关联类型",
    postposition_days: "后置天数",
    plan_time: "计划日期",
    plan_start_time: "计划开始日期",
    plan_end_time: "计划完成日期",
    actual_st: "实际工时",
    capacity_ratio: "产能比率",
    delivery_date: "交货日期",
    delivery_date_change_count: "变更次数",
    delay_days: "延迟天数",
    unit_price: "单价",
    force_time: "强制时间区间",
    yes: "是",
    no: "否",
    plan_node_select: "选择计划节点",
    relation_plan_start_time: "关联计划开始日",
    relation_plan_end_time: "关联计划完成日",
    move_down: "下移",
    move_up: "上移",
    when_change_node_code:
      "正在修改节点编码，将会导致重新计算节点加工进度，此操作比较耗时，确定要执行操作吗？",
    master_plan_number: "主计划节点数量",
    import_other_plan_node: "导入其他生产工单主计划",
    import_project_other_plan_node: "导入其他项目主计划",
    node_is_used_can_not_change_type: "节点使用中，不能修改节点类型!"
  },
  project_master_plan_template_setting: {
    master_plan_template: "主计划模板",
    template: "模板",
    template_name: "模板名称",
    template_type: "模板类型",
    plan_node_list: "计划节点列表",
    import: "导入",
    import_template: "导入模板",
    message_please_select_template_to_import: "请选择要导入的模板",
    confirm_import_template: "确定要导入模板[%1]中的计划节点吗？"
  },
  cas_login: {
    cas_login_message_authentication_failure: "认证失败，不能登录!",
    cas_login_message_employee_not_found: "认证失败，没有找到对应用户!",
    cas_login_message_factory_not_found: "认证失败，没有找到对应厂区!"
  },
  project_manage: {
    add_project: "新建项目",
    modify_project: "编辑项目",
    add_sub_project: "新建子项目",
    save_and_add_subprojects: "保存并添加子项目",
    save_and_add_peer_projects: "保存并添加同级项目",
    edit_project: "编辑",
    delete_project: "删除",
    project_plan: "项目计划",
    add_produce_order: "新增生产工单",
    add_project_order: "新增项目工单",
    parent_project_code: "上级项目编码",
    project_classify: "项目类型",
    project_code: "项目编码",
    project_name: "项目名称",
    project_order_code: "项目工单",
    custom: "客户",
    custom_code: "客户编码",
    custom_name: "客户名称",
    end_custom: "终端客户",
    end_custom_code: "终端客户编码",
    end_custom_area: "终端客户区域",
    project_leader: "负责人",
    input_time: "录入时间",
    delivery_time: "项目交期",
    project_ratio: "进度",
    project_amount: "项目金额",
    budget_amount: "预算金额",
    receivable_amount: "应收金额",
    unpaid_amount: "可收金额",
    paid_amount: "已付金额",
    budget_manage: "预算管理",
    designated_responsible_person: "指定责任人",
    no_responsible_person: "无责任人"
  },
  download: {
    offLineTools: {
      title: "MES线下辅助工具",
      describe:
        "用于导入排程数据以及在文件管理中，上传、打开线下文件（支持ftp、sftp、本地文件）。如果使用到了自动排程或文件管理模块，必须下载该软件配合使用。软件为托盘程序，启动后自动运行在系统托盘中。支持Windows7、windows8、windows10。",
      language: "语言",
      file_name: "文件名称",
      size: "大小",
      download: "下载"
    }
  },
  forms: {
    monitoring_platform: "监控平台",
    details_of_staff_daily: "员工日报明细",
    process_in_machining: "加工中工艺",
    department: "部门",
    export_config: "导出设定",
    export_column_selector: "选择导出列",
    process_status: "工艺状态",
    mach_status: "加工状态",
    performance_total_amount: "实绩金额",
    standard_total_amount: "标准金额",
    performance_summary: "实绩汇总报表",
    actual_amount: "实绩金额",
    standard_amount: "标准金额",
    abnormal_working_hours: "异常工时",
    abnormal_cost: "异常成本",
    unplanned_hours: "计划外工时",
    unplanned_amount: "计划外金额",
    rate_of_progress: "进度率",
    report_quality_department: "质量报表",
    workshop_report: "车间报表",
    quality_report: "质量报表",
    processing_mode: "处理方式",
    quality_state: "质量状态",
    number_errors: "错误件数",
    discovery_time: "发现时间",
    component_type: "零件类型",
    outside_and_purchase_process: "外协/采购",
    details_of_cost_report: "实绩明细报表",
    indirect_code: "间接编码",
    indirect_date: "间接时间",
    outside_the_plan: "计划外",
    inside_the_plan: "计划内",
    parts_and_processes: "零件&工艺",
    discard_time: "报废工时",
    rework_time: "返工工时",
    cost_report: "成本报表",
    standard_preparation_time: "标准准备工时",
    standard_manpower_hours: "标准人力工时",
    standard_device_hours: "标准设备工时",
    performance_preparation_time: "实绩准备工时",
    performance_manpower_hours: "实绩人力工时",
    performance_device_hours: "实绩设备工时",
    submit_cost_details: "成本科目报表",
    plan_amount: "计划金额",
    abnormal_amount: "异常金额",
    cost_type_manage_children: "子费用类型",
    planned_cost: "计划成本",
    actual_cost: "实际成本",
    settlement_cost: "结算成本",
    standard_cost: "标准成本",
    gross_profit: "毛利润",
    total_planned_hours: "计划总工时",
    total_actual_hours: "实际总工时",
    total_abnormal_hours: "异常总工时",
    total_unplanned_hours: "计划总工时",
    total_unplanned_cost: "计划外成本",
    processing_cost: "加工成本",
    outside_process_cost: "外协成本",
    procurement_cost: "采购成本",
    quality_analysis_report: "质量分析报表",
    error_type: "错误类型",
    wrong_number: "错误数量",
    responsible_team: "责任班组",
    responsible_supplier: "责任供应商",
    statistical_histogram: "统计柱状图",
    quality_management_report: "质量管理报表",
    part_and_process_schedule: "计划需求报表",
    details_of_device_daily: "设备日报明细",
    alert_of_staff_abnormal: "报工异常预警",
    processing_timeout: "加工超时",
    plan_daily_report: "日计划报表",
    part_warehouse_status_analysis: "零件进度报表",
    finish_num: "完工数量",
    inventory_num: "入库数量",
    not_inventory_num: "未入库数量",
    inventory_type: "入库类型",
    part_put_in_storage: "零件入库",
    order_put_in_storage: "订单入库",
    total_weight: "总重",
    employee_salary_detail: "员工工资明细",
    valuation_weight: "计价单量",
    valuation_weight_total: "计价总量",
    process_money: "工艺总价",
    valuation_method: "计价方式",
    fixed_salary: "固定工资",
    overtime_money: "加班工资",
    overtime_hours: "加班时长",
    total_wages: "总工资",
    share_cost_details: "分摊成本报表",
    order_cost_settlement: "工单成本结算",
    cost_allocation_statement: "公用成本分摊结算表(月)",
    cost_sharing_rate_statement: {
      title: "分摊费用率结算表(月)",
      month_standard_st: "当月工艺标准工时(h)",
      standard_share_ratio: "标准分摊比例（%）",
      month_act_st: "当月工艺实绩工时(h)",
      act_share_ratio: "实绩分摊比例（%）",
      process_share_amount: "工艺分摊金额(元）",
      standard_share_amount: "二次分摊标准工时金额（元）",
      standard_share_amount_count: "合计分摊标准工时金额（元）",
      act_share_amount: "二次分摊实绩工时金额（元）",
      act_share_amount_count: "合计分摊实绩工时金额（元）",
      standard_st_ratio: "标准工时费用率(元）",
      act_st_ratio: "实绩工时费用率（元）"
    },
    order_cost_statement: {
      title: "工单完工成本结算表(月)",
      bom_mat_cost: "BOM材料成本（元）",
      plan_produce_cost: "制造成本（元）",
      plan_outside_cost: "外协成本（元）",
      standard_pick_cost: "领料成本(元）",
      standard_produce_cost: "制造成本（元）",
      standard_outside_cost: "外协成本（元）",
      settlement_pick_cost: "领料成本(元）",
      settlement_produce_cost: "制造成本（元）",
      settlement_outside_cost: "外协成本（元）",
      gross_profit: "毛利润（元）",
      gross_profit_ratio: "毛利润率（%）"
    }
  },
  recovery: {
    title: "删除数据恢复",
    recovery: "恢复",
    delete_user: "删除人",
    delete_time: "删除时间",
    recovery_order: "确定要恢复选中的【%1】条数据?",
    recovery_mach:
      "确定要恢复选中的【%1】条报工记录？恢复后，需要手动调整对应报工的数量、工时"
  },
  customer_form: {
    project: "项目",
    order: "工单",
    part: "零件",
    process: "工艺",
    report: "报工"
  },
  materiel: {
    materiel_manage: "物料管理",
    materiel: "物料",
    materiel_code: "物料编码",
    materiel_name: "物料名称",
    materiel_type: "物料类型",
    materiel_type_code: "物料类型编码",
    materiel_type_name: "物料类型名称",
    materiel_type_attr: "物料类型属性",
    order_number_character: "订单号字符",
    company: "单位",
    email_account: "邮箱账号",
    mailbox_password: "邮箱密码",
    mailbox_port: "邮箱端口",
    send_test_email: "发送测试邮件",
    whether_process_personnel: "是否工序人员",
    sales_standard_unit_price: "销售标准单价",
    internal_unit_price: "内部单价",
    unit_price_of_mould_labor: "模具人工单价",
    unit_price_of_mould_cost: "模具费用单价",
    unit_price_of_tooling_labor: "工装人工单价",
    unit_price_of_tooling_cost: "工装费用单价",
    item_type_attribute: "物料类型属性",
    standard: "标准",
    knife_handle: "刀柄类",
    tool_class: "刀具类",
    parent_expense_type: "父费用类型",
    expense_type: "费用类型",
    safety_stock: "安全库存",
    maximum_inventory: "最大库存",
    attribute: "属性",
    material_status: "物料状态",
    tool_properties: "刀具属性",
    crude: "粗",
    fine: "细",
    diameter: "直径",
    blade_length_or_knife_length: "刃长/刀长",
    life: "寿命",
    attribute_class: "属性大类",
    attribute_subclass: "属性子类",
    sort_sequence_number: "排序序号",
    attribute_value: "属性值",
    bom_display: "BOM显示",
    standard_classification: "标准分类",
    growth_value: "增长值"
  },
  numerical_control_system_management: {
    nc_sys_name: "数控系统名称",
    nc_sys_version: "版本号",
    param_name: "参数名称",
    enable_status: "启用状态",
    move: "移动"
  },
  iot: {
    history_data: "历史数据",
    device_monitor: "设备监控",
    Building_management: "楼栋管理",
    Floor_management: "楼层管理",
    Regional_management: "区域管理",
    workshop: "车间名称",
    Workshop_management: "车间管理",
    leader: "负责人",
    Workshop_device_manage: "车间设备管理",
    Parameter_management_of_numerical_control_system: "数控系统管理",
    error_please_input_building_name: "请输入楼栋名称",
    error_please_input_floor_name: "请输入楼层名称",
    error_please_input_region_name: "请输入区域名称",
    error_please_input_workshop_name: "请输入车间名称",
    device: "设备",
    factory: "厂区",
    Building: "楼栋",
    floor: "楼层",
    region: "区域",
    device_real_time_monitor: "设备实时监控",
    error_please_select_factory: "请选择厂区!",
    error_please_select_building: "请选择楼栋!",
    error_please_select_floor: "请选择楼层!",
    all_region: "全部区域",
    Equipment_abnormal_Kanban: "设备异常看板",
    Workshop_leader: "车间负责人",
    Number_of_alarm: "报警次数",
    utilization: "稼动率",
    Real_time_alarm_information_of_equipment: "设备实时报警信息",
    Alarm_code: "报警代码",
    Alarm_content: "报警内容",
    Trigger_time: "触发时间(s)",
    Duration: "持续时间(s)",
    Operation_coding: "操作编码",
    Operation_name: "操作名称",
    Executable_file: "执行文件",
    d24_hour_Top5_anomaly: "24小时Top5异常",
    d24_hour_abnormal_detail: "24小时异常明细",
    Abnormality_times: "异常次数",
    Abnormal_time_statistics: "异常时间统计(s)",
    Processing_information: "加工参数",
    Equipment_offline: "设备离线",
    Equipment_idle: "设备空闲",
    Equipment_operation: "设备运行",
    Equipment_alarm: "设备报警",
    loss_time: "损失时间(s)",
    daily_statistics_of_device_operation_rate: "设备运转率统计(日度)",
    monthly_statistics_of_device_operation_rate: "设备运转率统计(月度)",
    daily_statistics_of_device_alarm: "设备报警统计(日度)",
    monthly_statistics_of_device_alarm: "设备报警统计(月度)",
    daily_statistics_of_device_operation_time: "设备运转时间统计(日度)",
    monthly_statistics_of_device_operation_time: "设备运转时间统计(月度)",
    device_run_info: "设备运转信息",
    date: "日期",
    time: "时间",
    alarm_count: "报警次数",
    alarm_time: "报警时间",
    powder_time: "通电时间",
    down_time: "离线时间",
    wait_time: "待机时间",
    manual_time: "手动时间",
    cutting_time: "切削时间",
    wait_rate: "待机率",
    alarm: "报警",
    alarm_stop_rate: "报警停机率",
    start_time: "开始时间",
    end_time: "结束时间",
    duration: "持续时间",
    status_title: "设备状态变动历史",
    device_running_status: "设备运行状态",
    mach_type: "加工类型"
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/cn.js